import React from 'react';

import { Box, Typography } from '@mui/material';
import { AutocompleteCDS, DataFieldCDS } from '@sharedCR/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { FieldInputType } from 'constants/fields';
import { feeCreditSourceOptions } from 'constants/loanFee';

import { LoanFeesTestIds } from '../../../../LoanFees.testIds';

import { containerStyles } from './ApplyCreditModal.styles';

const ApplyCreditModal = ({ form, validationErrors, onChange, onCreditSourceChange }) => (
  <Box sx={containerStyles}>
    <Typography variant="regular14">
      Apply a credit to reduce the borrower-paid amount for this fee.
    </Typography>

    <AutocompleteCDS
      fullWidth
      dataTestId={LoanFeesTestIds.APPLY_CREDIT_SOURCE_SELECT}
      error={!!validationErrors.creditSource}
      helperText={validationErrors.creditSource}
      id="creditSource"
      label="Credit Source"
      name="creditSource"
      options={feeCreditSourceOptions}
      placeholder="Select source"
      size="small"
      value={form.creditSource}
      onChange={onCreditSourceChange}
    />

    <DataFieldCDS
      fullWidth
      noValidate
      error={!!validationErrors.amount}
      helperText={validationErrors.amount}
      id="amount"
      label="Credit Amount"
      name="amount"
      placeholder="$0.00"
      size="small"
      type={FieldInputType.CURRENCY}
      value={form.amount}
      onChange={onChange}
    />
  </Box>
);

ApplyCreditModal.propTypes = {
  form: PropTypes.shape({
    creditSource: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  validationErrors: PropTypes.shape({
    creditSource: PropTypes.string,
    amount: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onCreditSourceChange: PropTypes.func.isRequired,
};

export default ApplyCreditModal;
